export default __webpack_public_path__ + "static/media/icn-leftarrow-drk.47474570.svg";